export default "__VITE_ASSET__AyKeSNv6__"